var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.045,9.517L4.045,18.022C4.045,18.137 4.065,18.249 4.101,18.352L4.104,18.36C4.141,18.463 4.195,18.562 4.268,18.652C5.445,20.102 7.827,22.949 12,22.949C16.173,22.949 18.555,20.102 19.732,18.652C19.805,18.562 19.859,18.463 19.896,18.36L19.899,18.352C19.935,18.249 19.955,18.137 19.955,18.022L19.955,14.524C19.955,13.972 19.507,13.524 18.955,13.524C18.403,13.524 17.955,13.972 17.955,14.524L17.955,17.667C16.949,18.898 15.117,20.949 12,20.949C8.883,20.949 7.051,18.898 6.045,17.667L6.045,10.569L11.535,13.454C11.826,13.607 12.174,13.607 12.465,13.454L21.017,8.959L21.017,14.524C21.017,15.076 21.465,15.524 22.017,15.524C22.569,15.524 23.017,15.076 23.017,14.524L23.017,7.366C23.017,7.356 23.017,7.345 23.016,7.335C23.017,7.325 23.017,7.314 23.017,7.304C23.017,6.932 22.811,6.592 22.482,6.419L12.465,1.154C12.174,1.001 11.826,1.001 11.535,1.154L1.518,6.419C1.189,6.592 0.983,6.932 0.983,7.304C0.983,7.675 1.189,8.016 1.518,8.189L4.045,9.517ZM12,3.169L19.867,7.304C19.867,7.304 12,11.439 12,11.439C12,11.439 4.133,7.304 4.133,7.304L12,3.169Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.17e086e5.svg";
export { ForwardRef as ReactComponent };